import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

/**
 * HomePage - Single Tenant
 * 
 * Redireciona automaticamente para:
 * - /dashboard se já estiver autenticado
 * - /login se não estiver autenticado
 */
const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, loading } = useAuth();

  useEffect(() => {
    if (!loading) {
      if (isAuthenticated && user) {
        // Redirecionar baseado no role
        switch (user.role) {
          case 'ASSOCIACAO':
            navigate('/dashboard', { replace: true });
            break;
          case 'USUARIO_FINAL':
            navigate('/user/campaigns', { replace: true });
            break;
          default:
            navigate('/login', { replace: true });
        }
      } else {
        // Não autenticado, ir para login
        navigate('/login', { replace: true });
      }
    }
  }, [isAuthenticated, user, loading, navigate]);

  // Tela de loading enquanto verifica autenticação
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2
      }}
    >
      <CircularProgress size={48} />
      <Typography variant="body1" color="text.secondary">
        Carregando...
      </Typography>
    </Box>
  );
}; 
export default HomePage;